import 'scss/document/error-code.scss'
import 'babel-polyfill'
import { suspension } from 'js/libs/utils-suspension'
import { config } from 'config'
import * as databaseAPI from 'js/api/document'
import { toUrl, getQueryString } from 'js/libs/utils'

$(function () {
  // 创建pageList是为了防止部分情况下scroll事件多次触发
  var pageList = []
  // 根据链接code参数获取错误码信息,筛选非数字数据
  var code = getQueryString('code')
  if (code) {
    code = code.replace(/[^\d]/g, '')
  }
  if (code) {
    getErrorCodeInfo(code)
    $('#errorCode').val(code)
  } else {
    getAllErrorCodeInfo()
  }
  // 输入框策略，输入框为空显示全部数据，输入框为五位数据自动搜索
  $('#errorCode').on('input', function (e) {
    if ($('#errorCode').val() === '' && code !== '') {
      code = ''
      $('.icon-search').trigger('click')
    } else if ($('#errorCode').val().length === 5 && $('#errorCode').val() !== code) {
      code = $('#errorCode').val()
      $('.icon-search').trigger('click')
    }
  })
  $(document).keyup(function (event) {
    if (event.keyCode === 13 || event.keyCode === '13') {
      $('.icon-search').trigger('click')
    }
  })
  $('.icon-search').click(function () {
    code = $('#errorCode').val()
    pageList = []
    changeUrl(code)
    if (code) {
      getErrorCodeInfo(code)
    } else {
      getAllErrorCodeInfo()
    }
  })
  suspension()
  // 获取所有错误码相关信息
  function getAllErrorCodeInfo (code, page) {
    page = page || 1
    databaseAPI.getErrorCodeInfo(code, page).then(function (result) {
      var codeInfo = ''
      var codeInfoList = []
      var trList = ''
      if (result.code === 0 || result.code === '0') {
        pageList[page - 1] = true
        codeInfo = result.data
        codeInfoList = codeInfo.content
        for (var i = 0; i < codeInfo.numberOfElements; i++) {
          trList += getTrList(codeInfoList[i])
        }
        if (codeInfo.first) {
          $('.query-result-contain').empty().append(getThList())
        }
        $('#error-code-table-list').append(trList)
        if (!codeInfo.last && !pageList[page]) {
          page++
          bindScrollLoad(page)
        }
      } else {
        $.alerts.alert('错误码信息获取失败： ' + result.desc)
      }
    })
  }

  // 获取某个错误码相关信息，和上面的代码分开写是因为接口返回数据格式不同
  function getErrorCodeInfo (code) {
    $(window).off('.myScroll')
    databaseAPI.getErrorCodeInfo(code).then(function (result) {
      var codeInfo = ''
      var trList = ''
      if (result.code === 0 || result.code === '0') {
        codeInfo = result.data
        if (codeInfo) {
          trList += getTrList(codeInfo)
          $('.query-result-contain').empty().append(getThList())
          $('#error-code-table-list').append(trList)
        } else {
          notFound()
        }
      } else {
        $.alerts.alert('错误码信息获取失败： ' + result.desc)
      }
    })
  }

  // 表格数据模板字面量
  function getTrList (item) {
    var trList = ''
    var trUrl = ''
    handleStr(item)
    item.solution = linkfilter(item.solution)
    if (item.reference && item.reference !== '无') {
      item.reference = linkfilter(item.reference)
      trUrl = `${item.reference}`
    } else {
      trUrl = '<div class="no-tr-url">无</div>'
    }
    trList += `<tr class="error-code-list">
      <td>${item.errorCode}</td>
      <td>${item.explanation}</td>
      <td>${item.errorCause}</td>
      <td>${item.solution}</td>
      <td>${trUrl}</td>
    </tr>`
    return trList
  }

  // 表格头模板字面量
  function getThList () {
    return `<table height="76">
    <thead>
      <tr class="error-code-table-head">
        <th>错误码</th>
        <th>错误码解释</th>
        <th>报错原因</th>
        <th>解决方案</th>
        <th>论坛参考</th>
      </tr>
    </thead>
    <tbody id="error-code-table-list"></tbody>
  </table>`
  }

  // 未查询到数据模板字面量
  function notFound () {
    $(window).off('.myScroll')
    var tip = `<p class="not-found-tip">未查询到 ${$('#errorCode').val()} 错误码信息，如遇到其他问题，可以在支持中心 <a class="bbs-link" href="${config.CONSOLE}workorder/commit" target="_blank">提交问题</a> 。</p>`
    $('.query-result-contain').empty().append(tip)
  }

  // 绑定滚动事件
  function bindScrollLoad (page) {
    var $window = $(window)
    var $document = $(document)
    $window.on('scroll.myScroll', function () {
      var drop = 360
      if (($document.scrollTop() + $window.height() + drop) > $document.height() && !pageList[page - 1]) {
        pageList[page - 1] = true
        getAllErrorCodeInfo('', page)
        $window.off('.myScroll')
      }
    })
  }

  // 提取文本中的链接
  function linkfilter (msg) {
    var url = msg
    var urlRegExp = new RegExp('(https:|http:|doc.)[a-zA-Z0-9/?&=._]+')
    var newmsg = ''
    while (urlRegExp.exec(url) != null) {
      var pipeiurl = urlRegExp.exec(url)
      var newurl = ''
      // 为doc.开头的链接添加域名，避免href跳转错误
      if (pipeiurl[0].indexOf('doc.') > -1) {
        newurl = `<a class="bbs-link" href="https://${pipeiurl[0]}" target="_blank">${pipeiurl[0]}</a>`
      } else {
        newurl = `<a class="bbs-link" href="${pipeiurl[0]}" target="_blank">${pipeiurl[0]}</a>`
      }
      var urllength = pipeiurl[0].length
      var start = url.indexOf(pipeiurl[0])
      newmsg += url.substring(0, start) + newurl
      url = url.substring(start + urllength)
    }
    msg = newmsg + url
    return msg
  }

  // 对\n\t\s字段处理，使文本在页面上按一定格式呈现，
  // 之所以将\s替换成‘ ’，而不是&npsb，是因为数据库返回的数据处理不当，前端使用&npsb会影响链接url的判断
  function handleStr (str) {
    for (var key in str) {
      if (typeof str[key] === 'string' && (str[key].indexOf('\n') > -1 || RegExp(/\s/).test(str[key]))) {
        str[key] = str[key].replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\s/g, ' ')
      }
    }
  }

  // 通过history.pushState实现无刷新修改url链接，不支持低版本浏览器
  function changeUrl (code) {
    if (window.history.pushState) {
      window.history.pushState(null, null, '?code=' + code)
    } else {
      window.open('/document/error-code?code=' + code, '_self')
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/entry/document/error-code.js